@for (hotel of hotels; track hotel; let i = $index) {
  <am-hotel [isLanding]="isLanding$ | async" [hotel]="hotel" [query]="query$ | async" [isMobile]="isMobile$ | async"
    [DEFAULT_IMAGE]="defaultImage" [urlResize]="urlResize" [locale]="locale$ | async" [nearBy]="nearByFilter"
    [hasRelated]="hotels && hotels.length > 1" [index]="i" class="mb-grid-col-12-dt"></am-hotel>
}